export default __webpack_public_path__ + "static/media/classical_music.7d808aed.jpg";